<!-- <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{inputInfo.title? inputInfo.title : 'Message'}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div> -->
  <div class="modal-body modal-data-responsive">
    <div>
      <div class="col-md-12 p-2 mb-2" *ngIf="inputInfo">
        <div class="row">
           <div class="col-md-12 text-center" *ngIf="inputInfo.icon">
          <!-- <img src="assets/images/logo.png" class='logo_img mt-3 mx-auto d-block' alt='logo' /> -->
           <img src="assets/svg/moments-logo-teal.svg" class='logo_img mt-3 mx-auto d-block' alt='logo' />
          </div>
          <div class="col-md-12 p-0 text-center" [ngClass]="{true:'col-md-8',false:'col-md-12'}[inputInfo.icon]"
            *ngIf="inputInfo.data">
            <ul class="message-class p-0 mb-0" [ngClass]="inputInfo.data.length == 1 ? 'alert-body':''"
              *ngIf="inputInfo.data.length > 0">
              <li *ngFor="let info of inputInfo.data;">
                <h3 *ngIf="info.heading" class="mb-1 mt-2 message-class d-flex align-items-center justify-content-center">
                  <img *ngIf="inputInfo.warningIcon" [src]="inputInfo.warningIcon" style="height: 22px; width: 22px;" alt="warning" class="me-1" />
                  {{info.heading}}
                </h3>
                <h5 *ngIf="info.SubHeading" class="message-class m-0" [innerHtml]="info.SubHeading"></h5>
                <h5 *ngIf="info.SubHeading1" class="message-class retry-color mt-2" [innerHTML]="info.SubHeading1"></h5>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer p-0 d-block">
    <div *ngIf="!inputInfo?.isRightAlignedButton" class="col-md-12 p-0 d-flex justify-content-center">
      <button *ngIf="inputInfo.buttons?.length == 0" class="btn btn_secondary col-md-12 btn-modal"
      style="cursor:pointer" (click)="activeModal.close('Save click');" ngbAutofocus>OK</button>
      <ng-container *ngFor="let btnInfo of inputInfo.buttons; let this_index = index">
        <ng-container *ngIf="(this_index+1) === inputInfo.buttons.length else noFocusBtn">
          <button class="btn btn-modal btn_primary mx-2 col-md-{{btnInfo.cols || 6}}" [ngClass]="btnInfo.class"
          style="cursor:pointer" (click)="activeModal.close(btnInfo.type);" ngbAutofocus>{{btnInfo.label}}</button>
        </ng-container>
        <ng-template #noFocusBtn>
          <button class="btn btn-modal btn_secondary ml-2 col-md-{{btnInfo.cols || 6}}" [ngClass]="btnInfo.class"
          style="cursor:pointer" (click)="activeModal.close(btnInfo.type);">{{btnInfo.label}}</button>
        </ng-template>
      </ng-container>
    </div>
    <div *ngIf="inputInfo?.isRightAlignedButton" class="col-md-12 px-4 d-flex" style="justify-content: end;">
      <ng-container *ngFor="let btnInfo of inputInfo.buttons; let this_index = index">
      <button class="btn btn-modal ml-2 col-md-{{btnInfo.cols || 6}}" [ngClass]="btnInfo.class"
      style="cursor:pointer;" (click)="activeModal.close(btnInfo.type);">{{btnInfo.label}}</button>
      </ng-container>
    </div>
  </div>
